'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 60px;\n  height: 60px;\n  z-index: 50000000000000000;\n  position: fixed;\n  border-radius: 5px;\n  border-width: 3px;\n  border-style: solid;\n  border-color: ', ';\n  ', '\n'], ['\n  width: 60px;\n  height: 60px;\n  z-index: 50000000000000000;\n  position: fixed;\n  border-radius: 5px;\n  border-width: 3px;\n  border-style: solid;\n  border-color: ', ';\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          bottom: 30px;\n          right: 30px;\n        '], ['\n          bottom: 30px;\n          right: 30px;\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n          left: 30px;\n          bottom: 30px;\n        '], ['\n          left: 30px;\n          bottom: 30px;\n        ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors


var Thumbnails = _styledComponents2.default.div(_templateObject, _colors.white, function (_ref) {
  var landscape = _ref.landscape;
  return landscape ? (0, _styledComponents.css)(_templateObject2) : (0, _styledComponents.css)(_templateObject3);
});

exports.default = Thumbnails;